import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { FAQProvider } from './context/faq-context';
import { FAQComponent } from './faq-component';

export function FAQFactory() {
  return (
    <BaseLayoutFactory>
      <FAQProvider>
        <FAQComponent />
      </FAQProvider>
    </BaseLayoutFactory>
  );
}
